import { render, staticRenderFns } from "./TasksLogs.vue?vue&type=template&id=5139250a&scoped=true"
import script from "./TasksLogs.vue?vue&type=script&lang=js"
export * from "./TasksLogs.vue?vue&type=script&lang=js"
import style0 from "./TasksLogs.vue?vue&type=style&index=0&id=5139250a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5139250a",
  null
  
)

export default component.exports